import { instance2 } from "App/constants"
import { makeStyles } from "@material-ui/core/styles"
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme"
import { isEmpty } from "lodash"
import { isNull, oneMonthBeforeToday, today } from "App/utils/helpers"
import { LIST_URL_REGISTRASI } from "utils/registrations"
import { endOfDay, lastOfDay, startOfDay, validUTC } from "utils/dates"
import moment from "moment"

export const RESET_STATE_KUNJUNGAN_IGD = {
  jenis_layanan_id: "",
  kelaskunjungan_id: 6,
  patients_id: "",
  date: today(true),
  nama_rm: "",
  gender: "",
  umur: "",
  nohp: "",
  phone_number: "",
  address_now: "",
  pekerjaan: "",
  penanggung: "",
  nik: "",
  norm: "",
  company_id: null,
  company_name: "Pilih Perusahaan",
  jenis_layanan_print: "IGD",

  insurance_no: "",

  insurance_id: null,
  insurance_name: "Pilih Asuransi",

  norujukan: "",
  nokontrol: "",

  doctor_id: "",
  doctor_name: "Pilih Dokter",
  jenisrm: 2,

  id_triage: "",
  label_triage: "Pilih Triage",

  sebab_sakit: 0,
  no_sep: "",
  validasi_bpjs: true,
  remark: "",

  cara_masuk: "other",
  cara_masuk_name: "Lain-lain",
}

export const RESET_STATE_FORM_FILTER = {
  type_search: 0,
  type_rm: 0,
  qword: "",
  first_date: oneMonthBeforeToday(true),
  finish_date: endOfDay(true),
  status: 0,
  is_cancel: 0,
  doctor: null,
  doctor_name: "Pilih Dokter",
  pages: 1,
  limit: 10,
}

export const valueJenisRm = [
  {
    value: 1,
    label: "External",
  },
  {
    value: 2,
    label: "Internal",
  },
]

export const valueTypeSearch = [
  {
    label: "Semua",
    value: 0,
  },
  {
    label: "ID RM",
    value: 1,
  },
  {
    label: "ID Kunjungan",
    value: 7,
  },
  {
    label: "Nama",
    value: 2,
  },
  {
    label: "ID Tagihan",
    value: 3,
  },
  {
    label: "No Asuransi",
    value: 4,
  },
  {
    label: "No SEP",
    value: 5,
  },
  {
    label: "Created By",
    value: 6,
  },
]

export const validation = (formData) => {
  if (isEmpty(formData.nohp)) {
    return {
      state: false,
      message: "NO HP tidak boleh kosong",
    }
  } else if (formData.company_id === "") {
    return {
      state: false,
      message: "Perusahaan tidak boleh kosong",
    }
  } else if (isNull(formData.cara_masuk)) {
    return {
      state: false,
      message: "Cara masuk tidak boleh kosong",
    }
  } else if (formData.insurance_name === "BPJS") {
    if (isNull(formData.insurance_no)) {
      return {
        state: false,
        message: "Jika BPJS, No Asuransi tidak boleh kosong",
      }
    } else {
      return {
        state: true,
      }
    }
  } else {
    return {
      state: true,
    }
  }
}

export const STYLE_MASTER_GUDANG_UTAMA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
})

export const deleteKunjunganIgdById = async (id) => {
  try {
    await instance2.post(
      LIST_URL_REGISTRASI.kunjungan_igd.delete,
      {},
      {
        headers: {
          registration_id: id,
        },
      },
    )
    return {
      state: true,
      message: "Berhasil menghapus data",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterKunjunganIgd = async (formFilter, pages, limit) => {
  try {
    const api = await instance2.get(LIST_URL_REGISTRASI.kunjungan_igd.list, {
      params: {
        type_search: formFilter.type_search,
        type_rm: formFilter.type_rm,
        qword: formFilter.qword,
        first_date: validUTC(formFilter.first_date),
        finish_date: validUTC(formFilter.finish_date),
        status: formFilter.status,
        is_cancel: formFilter.is_cancel,

        doctor: formFilter.doctor === null ? "" : formFilter.doctor,
        pages,
        limit,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterKunjunganIgdExport = async (formFilter) => {
  try {
    const api = await instance2.get(LIST_URL_REGISTRASI.kunjungan_igd.export, {
      params: {
        type_search: formFilter.type_search,
        type_rm: formFilter.type_rm,
        qword: formFilter.qword,
        first_date: validUTC(formFilter.first_date),
        finish_date: validUTC(formFilter.finish_date),
        status: formFilter.status,
        is_cancel: formFilter.is_cancel,

        doctor: formFilter.doctor === null ? "" : formFilter.doctor,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByNoSEPandID = async (id, no_sep) => {
  try {
    const api = await instance2.get("/sep_regist/byregistsep", {
      headers: {
        id_registration: id,
        no_sep: no_sep,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
    }
  } catch (error) {
    return {
      state: false,
      data: null,
      message: error?.response?.data?.message,
    }
  }
}

export const getTriage = async (from, to) => {
  try {
    const res = await instance2.post(
      "/registration/registration/get_triagelist_emr",
      {
        valid_from: startOfDay(from),
        valid_to: lastOfDay(to),
      },
    )
    return {
      state: true,
      data: isNull(res.data.body) ? [] : res.data.body,
    }
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "idrm",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA RM",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "tagihan_id",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL REGISTRASI",
    align: "left",
    minWidth: "185px",
  },
  {
    id: "iscancel",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "110px",
  },
  {
    id: "nohp",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "rm_phone_number",
    disablePadding: false,
    label: "NO TLP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "doctor_fullname",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "company_name",
    disablePadding: false,
    label: "PERUSAHAAN",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "insurance_name",
    disablePadding: false,
    label: "ASURANSI",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "insurance_no",
    disablePadding: false,
    label: "NO ASURANSI",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "nosep",
    disablePadding: false,
    label: "NO SEP",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "date_ob",
    disablePadding: false,
    label: "TANGGAL LAHIR",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "umur",
    disablePadding: false,
    label: "UMUR",
    align: "left",
    sort: false,
    minWidth: "135px",
  },
  {
    id: "nama_ppk_perujuk",
    disablePadding: false,
    label: "PPK PERUJUK",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "nama_hak_kelas",
    disablePadding: false,
    label: "HAK KELAS",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "250px",
  },
  {
    id: "whycancel",
    disablePadding: false,
    label: "CATATAN BATAL",
    align: "left",
    minWidth: "250px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
]
